
const Data = [
    {
        link: "https://github.com/RajatJ00",
        title: "Git", icon: "FaGithub",
    },
    {
        link: "https://www.linkedin.com/in/rajat-jamgade-4b3a85209",
        title: "Linkedin", icon: "FaLinkedin",
    },
    {
        link: "mailto:rajatjamgade00@gmail.com",
        title: "rajatjamgade00@gmail.com", icon: "FaGoogle",
    },
    {
        link: "mailto:rajatjamgade00@outlook.com",
        title: "rajatjamgade00@outlook.com", icon: "PiMicrosoftOutlookLogoFill",
    },
]
export default Data;